import React, {useState} from "react";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { Row, Col, FormGroup } from "reactstrap";
import axios from "axios";
import {useHistory} from 'react-router-dom';
import { API_URL } from "../../constent";

import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  BlockDes,
  BackTo,
  PreviewCard,
  Button,
  RSelect,
} from "../../components/Component";


const AddPolicy = () => {

    const [policyname, setFirstname] = useState("");

    const [loading, setLoading] = useState(false);
    const history = useHistory();

    function submitdata(){
        const formdata = new FormData() 
        formdata.append('policyname' , policyname)

        setLoading(true);

        axios.post(`${API_URL}addpolicy`, formdata)
            .then((response)=>{
                console.log(response.data);
                if(response.data.status === 1){
                    setLoading(false);
                    history.push('/list-policy');
                }else{
                    setLoading(false);
                    alert(response.data.msg);
                }
            })
    }

  return (
    <React.Fragment>
      <Head title="Policy Add" />
      <Content page="component">

        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <BlockTitle tag="h5">Add Policy</BlockTitle>
            </BlockHeadContent>
          </BlockHead>
          <Row className="g-gs">
            <Col lg="12">
              <PreviewCard className="h-100">
                {/* <div className="card-head">
                  <h5 className="card-title">Contact Form</h5>
                </div> */}
                <form>
                  <FormGroup className="form-group">
                    <label className="form-label" htmlFor="cf-full-name">
                      Policy Name
                    </label>
                    <input type="text" id="cf-full-name" value={policyname} onChange={(e)=> setFirstname(e.target.value)} className="form-control" />
                  </FormGroup>

                  <FormGroup className="form-group">
                    <Button disabled={loading} type="button" color="primary" size="lg" onClick={()=>submitdata()} >
                      {loading ? 'Loading...' : 'Save'}
                    </Button>
                  </FormGroup>
                </form>
              </PreviewCard>
            </Col>
          </Row>
        </Block>

      </Content>
    </React.Fragment>
  );
};

export default AddPolicy;
